export default __webpack_public_path__ + "static/media/Geography01_00.f83d1e2c.png";